import React from "react";

import ReactDOM from "react-dom";

import { ToastContainer } from "react-toastify";

import App from "./App";
import "./index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import {
  registerChunkLoadRecovery,
  scheduleAppRefreshFlagClear,
} from "./utils/forceAppRefresh";

registerChunkLoadRecovery();

ReactDOM.render(
  <React.Fragment>
    <ToastContainer />
    <App />
  </React.Fragment>,
  document.getElementById("root")
);

// Do not clear the reload guard on boot — that re-armed infinite refresh loops
// when hashed chunks were still missing after a deploy/rollback.
scheduleAppRefreshFlagClear();

// Unregister any previously installed Workbox SW and wipe Cache Storage so ECS
// rollbacks/deploys actually reach the browser (SW precache was pinning old shells).
serviceWorkerRegistration.unregister();
reportWebVitals();
